import React, {useState,useEffect} from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';

import People from '@mui/icons-material/People';
import Engineering from '@mui/icons-material/Engineering';
import Inventory from '@mui/icons-material/Inventory';
import Category from '@mui/icons-material/Category';
import PendingActions from '@mui/icons-material/PendingActions';
import Unpublished from '@mui/icons-material/Unpublished';
import './style.css'
import { useSelector, useDispatch } from "react-redux";
import { getAllDashboardData } from "./dashboardAction";
import { Link, useNavigate } from 'react-router-dom';

export default function MediaControlCard() {
  const dispatch = useDispatch();

  const theme = useTheme();
  useEffect(() => {
    dispatch(getAllDashboardData());
  
}, []);
const { dashboarddata } = useSelector((state) => state.dashboardList);

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
      <Link to='/allUsers'>
      <Card sx={{ display: 'flex', marginRight: '16px'}} className='box'>
      <Box sx={{ display: 'flex', flexDirection: 'column'}} >
        <CardContent sx={{ flex: '1 0 auto' }}>
          <Typography component="div" variant="h5" style={{color:'white',fontFamily:'Times New Roman' , fontWeight:'600',fontSize:'20px'}}>
            Total Users
          </Typography>
          <Typography variant="subtitle1" color="text.secondary" component="div" style={{color:"white"}}>
            {dashboarddata.users}
          </Typography>
        </CardContent>
       
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          // bgcolor: 'primary.main',
          color: 'primary.contrastText',
          width: 101,
        }}
      >
        <People sx={{ fontSize: 70 }} style={{marginLeft:'71px'}} />
      </Box>
      </Card>
      </Link>
      <Link to='/supplierLists'>
      <Card sx={{ display: 'flex', marginRight: '16px' }} className='box'>
      <Box sx={{ display: 'flex', flexDirection: 'column'}}  >
        <CardContent sx={{ flex: '1 0 auto' }}>
          <Typography component="div" variant="h5" style={{color:'white',fontFamily:'Times New Roman' , fontWeight:'600',fontSize:'20px'}}>
            Total Suppliers
          </Typography>
          <Typography variant="subtitle1" color="text.secondary" component="div" style={{color:"white"}}>
          {dashboarddata.supplier}
          </Typography>
        </CardContent>
       
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          // bgcolor: 'primary.main',
          color: 'primary.contrastText',
          width: 101,
        }}
      >
        <Engineering sx={{ fontSize: 70 }} />
      </Box>
      </Card>
      </Link>
      <Link to='/productList'>
      <Card sx={{ display: 'flex', marginRight: '16px' }} className='box'>
      <Box sx={{ display: 'flex', flexDirection: 'column'}} >
        <CardContent sx={{ flex: '1 0 auto' }}>
          <Typography component="div" variant="h5" style={{color:'white',fontFamily:'Times New Roman' , fontWeight:'600',fontSize:'20px'}}>
            Total Products
          </Typography>
          <Typography variant="subtitle1" color="text.secondary" component="div" style={{color:"white"}}>
          {dashboarddata.product}
          </Typography>
        </CardContent>
       
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          // bgcolor: 'primary.main',
          color: 'primary.contrastText',
          width: 101,
        }}
      >
        <Inventory sx={{ fontSize: 70 }} />
      </Box>
      </Card>
      </Link>
      <Link to='/approvalCommissionList'>
      <Card sx={{ display: 'flex',marginTop:'10px' }} className='box' >
      <Box sx={{ display: 'flex', flexDirection: 'column'}} >
        <CardContent sx={{ flex: '1 0 auto' }}>
          <Typography component="div" variant="h5" style={{color:'white',fontFamily:'Times New Roman' , fontWeight:'600',fontSize:'20px'}} title='Pending Commission Approval'>
            Pending Approval
          </Typography>
          <Typography variant="subtitle1" color="text.secondary" component="div" style={{color:"white"}}>
          {dashboarddata.commission}
          </Typography>
        </CardContent>
       
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          // bgcolor: 'primary.main',
          color: 'primary.contrastText',
          width: 50,
        }}
      >
        <PendingActions sx={{ fontSize: 70,marginLeft:'8px' }} />
      </Box>
      </Card>
      </Link>

      <Card sx={{ display: 'flex',marginTop:'10px',marginLeft:'24px' }} className='box' >
      <Box sx={{ display: 'flex', flexDirection: 'column'}} >
        <CardContent sx={{ flex: '1 0 auto' }}>
          <Typography component="div" variant="h5" style={{color:'white',fontFamily:'Times New Roman' , fontWeight:'600',fontSize:'20px'}}>
            Pending Publish
          </Typography>
          <Typography variant="subtitle1" color="text.secondary" component="div" style={{color:"white"}}>
            0
          </Typography>
        </CardContent>
       
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          // bgcolor: 'primary.main',
          color: 'primary.contrastText',
          width: 50,
        }}
      >
        <Unpublished sx={{ fontSize: 70,marginLeft:'30px' }} />
      </Box>
      </Card>
      <Link to='/subproductList'>
      <Card sx={{ display: 'flex',marginTop:'10px',marginLeft:'30px'  }} className='box' >
      <Box sx={{ display: 'flex', flexDirection: 'column'}} >
        <CardContent sx={{ flex: '1 0 auto' }}>
          <Typography component="div" variant="h5" style={{color:'white',fontFamily:'Times New Roman' , fontWeight:'600',fontSize:'20px'}}>
            Total Sub Products
          </Typography>
          <Typography variant="subtitle1" color="text.secondary" component="div" style={{color:"white"}}>
          {dashboarddata.subproduct}
          </Typography>
        </CardContent>
       
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          // bgcolor: 'primary.main',
          color: 'primary.contrastText',
          width: 50,
        }}
      >
        <Category sx={{ fontSize: 70 }} />
      </Box>
      </Card>
      </Link>
    </div>
  );
}
